import './brand-logo.styles.scss';
import { BRAND, BRAND_NAME } from '@/utils/brand';

// The logo in each theme's style: an icon drawn in SVG plus the wordmark
// as styled text, so it fits any name. theme: hardwood | varsity | arena.
// tone: 'dark' on the header band, 'light' on a light page (landing).
const BrandLogo = ({ theme = 'hardwood', tone = 'dark', size = 'header' }) => (
    <span className={`brand-logo brand-${theme} brand-${tone} brand-${size}`} role='img' aria-label={BRAND_NAME}>
        <Icon theme={theme} />
        <span className='brand-word' aria-hidden='true'>{BRAND.word}</span>
        {BRAND.tag && <span className='brand-tag' aria-hidden='true'>{BRAND.tag}</span>}
    </span>
);

// Hardwood: a basketball. Varsity: a crest with the initial. Arena: the
// three-point arc.
const Icon = ({ theme }) => {
    if (theme === 'varsity') {
        return (
            <svg className='brand-icon' viewBox='0 0 40 46' aria-hidden='true'>
                <path d='M3 3h34v25c0 8-8 13-17 16C11 41 3 36 3 28z' className='crest-outer' />
                <path d='M7 7h26v20c0 6-6 10-13 12C13 37 7 33 7 27z' className='crest-inner' />
                <text x='20' y='29' textAnchor='middle' className='crest-letter'>{BRAND.word.charAt(0)}</text>
            </svg>
        );
    }
    if (theme === 'arena') {
        return (
            <svg className='brand-icon' viewBox='0 0 44 30' aria-hidden='true'>
                <path d='M3 27 A19 19 0 0 1 41 27' className='arena-arc' />
                <circle cx='22' cy='17' r='5' className='arena-ball' />
            </svg>
        );
    }
    return (
        <svg className='brand-icon' viewBox='0 0 40 40' aria-hidden='true'>
            <circle cx='20' cy='20' r='18' className='ball' />
            <g className='ball-seams'>
                <circle cx='20' cy='20' r='18' />
                <path d='M2 20h36M20 2v36M8 8c5 5 5 19 0 24M32 8c-5 5-5 19 0 24' />
            </g>
        </svg>
    );
};

export default BrandLogo
